import React from 'react'

import {
  HiArrowRightOnRectangle,
  HiOutlineCog6Tooth,
  HiOutlineUserGroup,
} from 'react-icons/hi2'

import { useAuthInfo, useLogoutFunction } from '@sweetauth/core'

import Avatar from '@/components/common/Avatar'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/common/DropdownMenu'

import { useSafePush } from '@/hooks/navigation/useSafePush'
import { useActiveOrgId } from '@/hooks/organization/useActiveOrgId'

interface ProfileDropdown {}

const ProfileDropdown: React.FC<ProfileDropdown> = () => {
  const { user } = useAuthInfo()
  const { activeOrgId } = useActiveOrgId()
  const { safePush } = useSafePush()

  const logout = useLogoutFunction()

  const handleLogout = () => {
    logout(true)
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="rounded-full border border-primary-300 dark:border-primary-700">
        <Avatar
          name={`${user?.firstName} ${user?.lastName}`}
          src={user?.pictureUrl}
          width={30}
          height={30}
          noTooltip={true}
          triggerClassName="cursor-pointer"
          delayFallback={100}
        />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem
          disabled={activeOrgId === ''}
          onClick={() => safePush(`/orgs/${activeOrgId}/profile`)}
        >
          <div className="flex items-center gap-2">
            <HiOutlineUserGroup className="h-4 w-4" />
            <p className="text-sm">Organization Profile</p>
          </div>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => safePush('/settings')}>
          <div className="flex items-center gap-2">
            <HiOutlineCog6Tooth className="h-4 w-4" />
            <p className="text-sm">Account Settings</p>
          </div>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={handleLogout}>
          <div className="flex items-center gap-2">
            <HiArrowRightOnRectangle className="h-4 w-4" />
            <p className="text-sm">Logout</p>
          </div>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default ProfileDropdown
